export default __webpack_public_path__ + "static/media/022-cargo-ship.32da4fd1.svg";